import { useAppSelector } from "../../../store/hooks";

function usePageLanguage() {
  const pageId = useAppSelector((state) => state.builder.pages.active);
  const currentPage = useAppSelector((state) =>
    state.builder.pages.list.find((x) => x.uuid === pageId)
  );
  if (
    currentPage &&
    typeof currentPage.languageCode === "string" &&
    currentPage.languageCode.trim() !== ""
  ) {
    return currentPage.languageCode.trim();
  }
  return "et";
}

export default usePageLanguage;
